import React from 'react'
import MetaTags from "react-meta-tags"
import { useEffect, useState } from 'react'
import { withRouter, useHistory } from "react-router-dom"
import { withTranslation } from "react-i18next"
import PropTypes from "prop-types"
import {
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Button,
    CardTitle,
    CardSubtitle,
    Label,
    Input,
    Container,
    CustomInput,
} from "reactstrap"
import { AvForm, AvField } from "availity-reactstrap-validation"
import Breadcrumbs from "../../components/Common/Breadcrumb"

const ChangePassword = props => {

    
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Change Password | Virtual Supermarket</title>
                </MetaTags>
                <Container fluid={true}>
                <Breadcrumbs
                        title={props.t("Home")}
                        breadcrumbItem={props.t("Change Password")}
                    />
                    <Row>
                        <Col></Col>
                        <Col xl="5">
                            <Card>
                                <CardBody>
                                    <AvForm className="needs-validation">
                                        <Row>
                                            <Col md="12">
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="Password"> Current Password</Label>
                                                    <AvField
                                                        name="CurrentPassword"
                                                        placeholder="Current Password"
                                                        type="text"
                                                        errorMessage="Please Enter Current Password"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id=" Current Password"
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="Password"> New Password</Label>
                                                    <AvField
                                                        name="NewPassword"
                                                        placeholder="New Password"
                                                        type="text"
                                                        errorMessage="Please Enter New Password"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="New Password"
                                                    />
                                                </FormGroup>
                                                <FormGroup className="mb-3">
                                                    <Label htmlFor="ConfirmPassword">Confirm Password</Label>
                                                    <AvField
                                                        name="ConfirmPassword"
                                                        placeholder="Confirm Password"
                                                        type="text"
                                                        errorMessage="Please Enter Confirm Passwordo"
                                                        className="form-control"
                                                        validate={{ required: { value: true } }}
                                                        id="ConfirmPassword"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                        <Button color="primary" type="submit">
                                            Submit 
                                        </Button>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                        <Col></Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}
ChangePassword.propTypes = {
    t: PropTypes.any,
}
export default withRouter(withTranslation()(ChangePassword))
